import { render, staticRenderFns } from "./SliderBlockTwo.vue?vue&type=template&id=0bb2d7df&"
import script from "./SliderBlockTwo.vue?vue&type=script&lang=js&"
export * from "./SliderBlockTwo.vue?vue&type=script&lang=js&"
import style0 from "./SliderBlockTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports